<template>
  <!-- eslint-disable -->
  <li class="block" ref="highlightblock">
    <svg
      :aria-label="
        `Activity ${blockIndex} of ${totalNumberOfBlocks} - ${active ? 'Completed' : 'Not Started'}`
      "
      enable-background="new 0 0 110.5 108.3"
      id="award-block"
      role="img"
      version="1.1"
      viewBox="0 0 110.5 108.3"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      y="0px"
      :aria-live="animate ? 'polite' : 'off'"
    >
      <path
        fill="#FF0000"
        ref="bg"
        d="M98.2,4.2l-0.3,0c-1.3-0.4-2.7-0.9-4.2-1.7c-1.7-0.1-4-0.3-6.8-0.6c-1.2-0.2-1.9-0.2-2.1-0.2h-0.4
        c-3.2,0.1-6.5,0.1-9.9,0l-0.2,0c-0.4,0.1-0.9,0.1-1.5,0.1c-1.5-0.2-3-0.2-4.8-0.1h-4.5c-1.3,0.1-2.7,0.1-4.1,0.1
        c-0.5,0-0.9-0.1-1.3-0.2c-0.5-0.2-1.1,0-1.9,0.4L56,2c-1.7-0.1-4.2-0.2-7.5-0.3h-3.8l-0.4,0c-0.4,0.1-1.2,0.1-2.4,0.1
        c-0.8-0.1-1.6-0.1-2.4-0.1c-1.5,0.1-3.7,0.1-6.6,0c-1.8-0.1-3.4,0-4.8,0.2L28,2c-0.9,0.3-1.8,0.2-2.5-0.2c0,0.3-0.1,0.5-0.1,0.5
        h-0.1c-1,0.2-2.3,0.3-3.8,0.3h-0.3c-0.3-0.1-0.6-0.1-1.1,0h-0.2c-0.4-0.3-0.7-0.1-1.1,0.5c-0.3-0.3-0.8-0.3-1.4,0
        c-0.6,0.2-1.1,0.2-1.4,0c-0.3,0.5-1,0.8-2,0.9L13.6,4c-0.8-0.3-1.1-0.1-1.1,0.6c-0.3,0-0.5,0-0.7-0.1l-0.3,0c-0.2,0.1-0.5,0-1-0.1
        C9.7,4,9.1,4.1,8.7,4.5L8.4,4.6C7.8,5.1,6.8,6,5.6,7.3c0,0.5-0.1,0.8-0.4,1C5.1,8.4,5,8.6,5,8.7c-0.3,0.7-0.5,1.1-0.5,1.5
        c-0.2,0.5-0.4,0.8-0.4,1c-0.5,1.4-0.9,3-1.1,4.7v0.4c0,0.7-0.1,1.2-0.3,1.5l-0.1,0.2c-0.2,0.9-0.3,2.1-0.2,3.8c0.1,1,0,1.6-0.2,1.8
        c0,0.3,0,0.5,0.1,0.6c0.1,0.1,0.1,0.2,0,0.3c-0.2,0.9-0.2,2,0,3.5c0.2,1.1,0,1.9-0.4,2.4c0.3,0.4,0.3,0.9,0.2,1.7L2,32.3
        C2.3,33,2.3,33.9,2,35v0.4c0.3,1.4,0.3,3,0,4.8v0.2c0.3,0.4,0.4,1,0.3,1.9c0,0.1,0,0.2-0.1,0.2C2,43,2,43.8,2.3,44.7
        c0.1,0.1,0.1,0.2,0,0.3C2.1,45.9,2,47,2,48.5l0,0.2c0.1,0.4,0.1,0.9,0.1,1.5c-0.1,0.6-0.1,1.2,0,1.8l0.3,2.4l0,6.5l0,0.3v1.8
        c-0.1,1-0.1,1.6,0,1.7V66c0,1.3,0.1,2.4,0.5,3.4H2.7c0.3,0.4,0.2,0.7-0.2,0.7c0.4,1,0.4,2.4,0.2,4.1l-0.1,1c-0.1,0.3,0,0.7,0.1,1
        c0.1,0.4,0.1,1.1,0,2.1l0,1.4c0,1.5,0.1,2.8,0.3,3.8l0,0.3c0.3,1.5,0.6,2.9,1,4.1c0.2,0.5,0.3,1.4,0.3,2.4C5,91.5,5.6,92.7,6.1,94
        c0.4,1.2,1.2,2.1,2.2,2.8l0,0.4c0,0.6,0.4,0.9,1,1c0,0.1,0,0.2,0.1,0.2c0.2,0.3,0.2,0.7,0.2,1.1c1.2,0.8,2.2,1.8,3,2.9
        c0.9,1.1,2.1,1.8,3.8,2.1c0.5,0.2,0.9,0.4,1.1,0.5l0.4,0c0.8-0.2,1.8-0.2,3.1,0v0.2c0.6-0.1,1,0.1,1.1,0.5c0.9,0,1.6,0,2,0.1l0.6,0
        c0.7-0.3,1.7-0.3,2.9-0.1v0.1c0.6-0.1,1,0.1,1,0.5c1.2,0,2.1,0,2.8,0.1h1.4c1.4-0.2,2.6-0.1,3.4,0.2c0.4-0.3,1.2-0.4,2.4-0.5
        c0.8-0.1,1.8-0.1,3.1,0c2.7,0.1,4.8,0.2,6.1,0.5c0.4-0.3,1.5-0.4,3.1-0.5h1.4l0.2-0.1c0.6-0.4,1.2-0.3,1.9,0.2c0.3-0.3,1-0.4,2-0.2
        l3.5,0.1c0.4,0.1,0.8,0.1,1.3-0.1c0.4-0.1,0.8-0.1,1.4,0.1c1,0.3,2.1,0.3,3.5,0c1.9-0.3,4.3-0.4,7.2-0.4h0.3c0.6,0.1,1.2,0.1,1.7,0
        c0.8,0,1.6,0,2.4,0h0.3c0.1-0.1,0.5-0.1,1.1-0.2l2.4-0.2c0.5-0.1,2-0.4,4.4-0.9h0.3c0.4,0.2,0.9,0.2,1.4,0.1
        c0.7-0.1,1.3-0.1,1.7-0.1c1.2,0.1,2.2,0.1,3.1-0.1c1.5-0.2,2.9-0.6,4.1-1.1c0.4-0.2,1.1-0.5,2-0.9c0.8-0.3,1.4-0.4,1.8-0.1
        c0-0.1,0.1-0.2,0.2-0.2c0.7-0.9,1.6-1.8,2.9-2.5l0.1-0.3c1.8-2.9,3.3-5.3,4.7-7.2c-0.1-1.2,0.1-2.2,0.5-3c0.6-1.1,0.5-1.9-0.2-2.5
        c-0.2-0.6-0.1-1,0.2-1.2v-0.2l-0.4-3.1c-0.2-1.5-0.2-3.2,0.1-5.1c0-0.6,0-1.2-0.1-1.8l0-0.2c-0.2-0.8-0.2-1.9,0-3.1l0-0.3
        c-0.2-0.9-0.2-2.3,0-4.1v-0.2c-0.3-0.4-0.4-1-0.2-1.9l0.2-2.1c0.1-0.7,0.1-1.5-0.1-2.4v-0.3c0.3-0.6,0.3-1.5,0.1-2.8l-0.1-0.4
        c0.2-0.3,0.2-0.7,0.1-1.4c-0.1-1-0.2-1.7-0.1-2.1l0-1.7l0-0.3c-0.2-1.1,0-1.8,0.5-2.1c-0.9-0.6-1-1.4-0.5-2.5l0-0.2
        c0.3-1.1,0.3-2.3,0-3.8l0-0.4c-0.2-1.4-0.2-2.2-0.2-2.4c0.2-1.4,0.2-2.7,0-3.8l-0.1-0.2c-0.1-0.9-0.2-1.7-0.2-2.4l-0.5-3.1
        c-0.1-0.6-0.1-1.4,0-2.4c0.1-0.1,0.1-0.2,0-0.2c-0.4-0.8-0.3-1.5,0.2-2.1l-0.3-0.1c-0.2,0-0.2-0.5,0-1.3H107l0-2.1
        c-0.3-1.7-0.5-3.5-0.6-5.5c0-0.3,0-0.5-0.1-0.7c-0.2-1.3-0.3-2.3-0.1-3.1l-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.3c-0.1-1-0.4-1.8-0.9-2.4
        c-0.6-0.8-1.4-1.5-2.1-2.3C101.1,6.8,99.7,5.4,98.2,4.2z"
      ></path>
      <g id="clipperMask" :class="{ hide: hideBg }">
        <defs>
          <path
            id="masker"
            d="M98.2,4.2l-0.3,0c-1.3-0.4-2.7-0.9-4.2-1.7c-1.7-0.1-4-0.3-6.8-0.6c-1.2-0.2-1.9-0.2-2.1-0.2h-0.4
            c-3.2,0.1-6.5,0.1-9.9,0l-0.2,0c-0.4,0.1-0.9,0.1-1.5,0.1c-1.5-0.2-3-0.2-4.8-0.1h-4.5c-1.3,0.1-2.7,0.1-4.1,0.1
            c-0.5,0-0.9-0.1-1.3-0.2c-0.5-0.2-1.1,0-1.9,0.4L56,2c-1.7-0.1-4.2-0.2-7.5-0.3h-3.8l-0.4,0c-0.4,0.1-1.2,0.1-2.4,0.1
            c-0.8-0.1-1.6-0.1-2.4-0.1c-1.5,0.1-3.7,0.1-6.6,0c-1.8-0.1-3.4,0-4.8,0.2L28,2c-0.9,0.3-1.8,0.2-2.5-0.2c0,0.3-0.1,0.5-0.1,0.5
            h-0.1c-1,0.2-2.3,0.3-3.8,0.3h-0.3c-0.3-0.1-0.6-0.1-1.1,0h-0.2c-0.4-0.3-0.7-0.1-1.1,0.5c-0.3-0.3-0.8-0.3-1.4,0
            c-0.6,0.2-1.1,0.2-1.4,0c-0.3,0.5-1,0.8-2,0.9L13.6,4c-0.8-0.3-1.1-0.1-1.1,0.6c-0.3,0-0.5,0-0.7-0.1l-0.3,0c-0.2,0.1-0.5,0-1-0.1
            C9.7,4,9.1,4.1,8.7,4.5L8.4,4.6C7.8,5.1,6.8,6,5.6,7.3c0,0.5-0.1,0.8-0.4,1C5.1,8.4,5,8.6,5,8.7c-0.3,0.7-0.5,1.1-0.5,1.5
            c-0.2,0.5-0.4,0.8-0.4,1c-0.5,1.4-0.9,3-1.1,4.7v0.4c0,0.7-0.1,1.2-0.3,1.5l-0.1,0.2c-0.2,0.9-0.3,2.1-0.2,3.8
            c0.1,1,0,1.6-0.2,1.8c0,0.3,0,0.5,0.1,0.6c0.1,0.1,0.1,0.2,0,0.3c-0.2,0.9-0.2,2,0,3.5c0.2,1.1,0,1.9-0.4,2.4
            c0.3,0.4,0.3,0.9,0.2,1.7L2,32.3C2.3,33,2.3,33.9,2,35v0.4c0.3,1.4,0.3,3,0,4.8v0.2c0.3,0.4,0.4,1,0.3,1.9c0,0.1,0,0.2-0.1,0.2
            C2,43,2,43.8,2.3,44.7c0.1,0.1,0.1,0.2,0,0.3C2.1,45.9,2,47,2,48.5l0,0.2c0.1,0.4,0.1,0.9,0.1,1.5c-0.1,0.6-0.1,1.2,0,1.8l0.3,2.4
            l0,6.5l0,0.3v1.8c-0.1,1-0.1,1.6,0,1.7V66c0,1.3,0.1,2.4,0.5,3.4H2.7c0.3,0.4,0.2,0.7-0.2,0.7c0.4,1,0.4,2.4,0.2,4.1l-0.1,1
            c-0.1,0.3,0,0.7,0.1,1c0.1,0.4,0.1,1.1,0,2.1l0,1.4c0,1.5,0.1,2.8,0.3,3.8l0,0.3c0.3,1.5,0.6,2.9,1,4.1c0.2,0.5,0.3,1.4,0.3,2.4
            C5,91.5,5.6,92.7,6.1,94c0.4,1.2,1.2,2.1,2.2,2.8l0,0.4c0,0.6,0.4,0.9,1,1c0,0.1,0,0.2,0.1,0.2c0.2,0.3,0.2,0.7,0.2,1.1
            c1.2,0.8,2.2,1.8,3,2.9c0.9,1.1,2.1,1.8,3.8,2.1c0.5,0.2,0.9,0.4,1.1,0.5l0.4,0c0.8-0.2,1.8-0.2,3.1,0v0.2c0.6-0.1,1,0.1,1.1,0.5
            c0.9,0,1.6,0,2,0.1l0.6,0c0.7-0.3,1.7-0.3,2.9-0.1v0.1c0.6-0.1,1,0.1,1,0.5c1.2,0,2.1,0,2.8,0.1h1.4c1.4-0.2,2.6-0.1,3.4,0.2
            c0.4-0.3,1.2-0.4,2.4-0.5c0.8-0.1,1.8-0.1,3.1,0c2.7,0.1,4.8,0.2,6.1,0.5c0.4-0.3,1.5-0.4,3.1-0.5h1.4l0.2-0.1
            c0.6-0.4,1.2-0.3,1.9,0.2c0.3-0.3,1-0.4,2-0.2l3.5,0.1c0.4,0.1,0.8,0.1,1.3-0.1c0.4-0.1,0.8-0.1,1.4,0.1c1,0.3,2.1,0.3,3.5,0
            c1.9-0.3,4.3-0.4,7.2-0.4h0.3c0.6,0.1,1.2,0.1,1.7,0c0.8,0,1.6,0,2.4,0h0.3c0.1-0.1,0.5-0.1,1.1-0.2l2.4-0.2
            c0.5-0.1,2-0.4,4.4-0.9h0.3c0.4,0.2,0.9,0.2,1.4,0.1c0.7-0.1,1.3-0.1,1.7-0.1c1.2,0.1,2.2,0.1,3.1-0.1c1.5-0.2,2.9-0.6,4.1-1.1
            c0.4-0.2,1.1-0.5,2-0.9c0.8-0.3,1.4-0.4,1.8-0.1c0-0.1,0.1-0.2,0.2-0.2c0.7-0.9,1.6-1.8,2.9-2.5l0.1-0.3c1.8-2.9,3.3-5.3,4.7-7.2
            c-0.1-1.2,0.1-2.2,0.5-3c0.6-1.1,0.5-1.9-0.2-2.5c-0.2-0.6-0.1-1,0.2-1.2v-0.2l-0.4-3.1c-0.2-1.5-0.2-3.2,0.1-5.1
            c0-0.6,0-1.2-0.1-1.8l0-0.2c-0.2-0.8-0.2-1.9,0-3.1l0-0.3c-0.2-0.9-0.2-2.3,0-4.1v-0.2c-0.3-0.4-0.4-1-0.2-1.9l0.2-2.1
            c0.1-0.7,0.1-1.5-0.1-2.4v-0.3c0.3-0.6,0.3-1.5,0.1-2.8l-0.1-0.4c0.2-0.3,0.2-0.7,0.1-1.4c-0.1-1-0.2-1.7-0.1-2.1l0-1.7l0-0.3
            c-0.2-1.1,0-1.8,0.5-2.1c-0.9-0.6-1-1.4-0.5-2.5l0-0.2c0.3-1.1,0.3-2.3,0-3.8l0-0.4c-0.2-1.4-0.2-2.2-0.2-2.4
            c0.2-1.4,0.2-2.7,0-3.8l-0.1-0.2c-0.1-0.9-0.2-1.7-0.2-2.4l-0.5-3.1c-0.1-0.6-0.1-1.4,0-2.4c0.1-0.1,0.1-0.2,0-0.2
            c-0.4-0.8-0.3-1.5,0.2-2.1l-0.3-0.1c-0.2,0-0.2-0.5,0-1.3H107l0-2.1c-0.3-1.7-0.5-3.5-0.6-5.5c0-0.3,0-0.5-0.1-0.7
            c-0.2-1.3-0.3-2.3-0.1-3.1l-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.3c-0.1-1-0.4-1.8-0.9-2.4c-0.6-0.8-1.4-1.5-2.1-2.3
            C101.1,6.8,99.7,5.4,98.2,4.2z"
          ></path>
        </defs>
        <clipPath id="masker_1_">
          <use xlink:href="#masker" overflow="visible"></use>
        </clipPath>

        <path
          id="animated-stroke"
          ref="path"
          class="path"
          clip-path="url(#masker_1_)"
          fill="none"
          stroke="#FFFFFF"
          stroke-width="30"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="
          M110.5,94.7C85.4,94.4,0.7,105.8-4.3,107.7c11-7.6,59.7-29.9,127.5-42.9c-19-0.3-104,7-127.5,20.3C0.3,80,107.9,40.7,117.6,31.4
          C88,19.6,1.2,61.8-4.3,54.9C-1.8,44.6,96,15,104.7,0.2C74.8-8.6,3.6,22.7,3.6,22.7"
        ></path>
      </g>
      <path
        id="topStroke"
        stroke="#757575"
        d="M53.4,107.6c-0.4-0.1-1,0.2-1.4,0.2c-0.8,0.1-1.6-0.1-2.3,0c-0.6,0.1-4.1,0.1-5.2,0c-1.5-0.1-3-0.2-4.5-0.1
        c-1.2,0-2.3,0.4-3.5,0.6c-0.8,0.1-1.8-0.4-2.7-0.3c-1.4,0-2.9,0-4.3,0c-0.4,0-3-0.4-3.3-0.4c0-0.1-1.2-0.2-1.9-0.2
        c-0.7,0-1.3-0.1-2-0.1c-1.1,0-5-0.6-5.6-0.8c-2-0.7-3.8-1.6-5.2-3.2c-0.7-0.8-1.3-1.3-2.1-2c-0.4-0.3-0.8-0.6-1-1.1
        c-0.1-0.3-0.1-0.6-0.2-0.9c-0.2-0.4-0.7-0.6-0.9-1c-0.2-0.3-0.3-0.7-0.6-1c-0.6-0.9-1.4-1.6-1.9-2.6c-0.5-1.1-1-2.1-1.5-3.2
        c-0.5-1-0.5-2.1-0.7-3.2c-0.4-2.3-1.2-4.6-1.3-7c-0.1-1.2,0-2.4,0.1-3.5c0-1.1-0.2-2.3-0.1-3.4c0.2-2.3-0.6-6.6-0.3-6.6
        c-0.4-2.9-0.1-6-0.1-9c0-1.4,0.1-2.7,0-4.1c0-1.3-0.3-2.6-0.3-3.9c0.1-1.3,0-2.7,0.1-4c0.1-1.4-0.1-2.8,0.1-4.1
        c0.2-1-0.3-1.7-0.2-2.7c0.1-1.5,0.1-2.9,0-4.4c0-1.2-0.1-2.5,0-3.7c0-0.7,0-0.8-0.3-1.3c-0.3-0.6-0.3-0.4,0.1-1
        C1,28.8,0.7,28,0.7,27c-0.1-1.3,0-2.6,0.1-4c0.2-1.3,0.1-2.6,0.1-3.9C1,17.7,1.5,16.4,1.7,15c0.3-1.3,0.5-2.6,0.8-3.9
        c0.4-1.4,1.1-2.5,1.5-3.9c0.6-2,3.3-4.5,5.4-4.5c0.6,0,1.2,0.2,1.8,0.1c0.5-0.1,0.9-0.4,1.4-0.5c0.6,0,1.3,0.4,1.9,0
        c0.4-0.3,2.6-0.7,4-1.1c1-0.3,1.9-0.1,2.9-0.1c0.6,0.1,1.9,0.3,2.3-0.1c0.5-0.4,2.4-0.4,4.1-0.6c1.8-0.3,3.7-0.3,5.5-0.3
        c3.6,0.1,7.1,0.3,10.7,0.1c1.8-0.1,3.6-0.1,5.4,0c1.9,0.1,4.1,0.4,6,0.2c0.7-0.1,1.3-0.3,2-0.4c0.7,0,1.4,0.1,2.1,0.2
        c1.9,0.2,3.9,0,5.8,0c3.8,0,7.5,0,11.3,0c3.6,0,7.3-0.3,10.9,0.1c1.6,0.2,3.3,0.4,4.9,0.5c1.6,0.1,2.6,0.7,4.1,1.2
        c1.5,0.5,2.5,0.8,3.7,2c1.3,1.2,2.7,2.4,3.9,3.7c0.6,0.6,1.2,1.3,1.7,2c0.5,0.6,0.6,1.4,1,2.1c0.2,0.3,0.7,0.5,0.8,0.7
        c0.2,0.4-0.1,1.1-0.2,1.6c-0.2,1.7,0.2,3.6,0.4,5.3c0.1,1,0.2,2.2,0.4,3.2c0.1,0.5,0.1,1.9,0.3,2.2c0.2,0.4-0.2,2,0,3.3
        c0.2,1.5,0.2,3,0.4,4.6c0.3,1.7,0.6,3.3,0.7,5c0.1,1.1-0.1,2.3,0,3.3c0.2,1.6,0.2,3.2,0.2,4.8c0,0.5,0,1.1-0.1,1.6
        c-0.1,0.6-0.3,0.7,0,1.2c0.4,0.6,0.5,1.8,0.1,2.3c-0.5,0.6-0.1,2.2-0.1,2.9c0,2.1,0.3,4.2,0.1,6.3c-0.1,1.2,0,2.3-0.1,3.5
        c-0.1,1.1-0.3,1.9-0.1,3c0.2,0.9,0,1.9-0.1,2.8c-0.1,1.2,0,2.4,0,3.6c0,2.2,0.2,4.3,0.1,6.6c-0.1,2.1-0.1,4.5,0.3,6.6
        c0.2,0.9,0.5,1.4,0.3,2.3c-0.3,1.1-0.6,1.9-0.7,3c-0.2,1.9-1.6,3.2-2.6,4.8c-0.7,1-1.4,2-1.9,3c-0.4,0.8-0.6,1.4-1.3,1.8
        c-0.6,0.4-1.5,0.6-2,1.3c-0.5,0.8-1.6,1.4-2.5,1.4c-0.9,0-1.7,0.6-2.4,0.9c-1.7,0.8-3.6,1.2-5.5,1.3c-2.2,0.1-4.5,0-6.7,0.3
        c-2.1,0.3-4.1,0.8-6.3,1c-4.2,0.3-8.5,0.1-12.7,0.6c-1.1,0.1-2.2,0-3.3-0.1c-1.1-0.1-2.1,0-3.2,0C57.7,107.8,53.8,107.7,53.4,107.6z
         M53.2,107.5L53.2,107.5L53.2,107.5z M78.6,107.3L78.6,107.3C78.6,107.3,78.6,107.3,78.6,107.3z M40.2,104.7c2.1,0,4.1,0.2,6.2,0.4
        c2.2,0.2,4.3-0.6,6.4-0.6c0.8,0,1.5,0.3,2.3,0.2c0.8,0,1.7,0,2.5,0c2.1,0.1,4.2,0,6.3,0.1c1.9,0.1,3.9-0.3,5.9-0.4
        c2.1-0.1,4.2-0.1,6.3-0.1c2.1,0,4.3-0.2,6.4-0.7c2.1-0.5,3.9-0.6,6-0.5c2,0,3.9-0.1,5.8-0.7c0.9-0.3,1.7-0.7,2.5-1
        c0.8-0.3,1.8-0.5,2.6-0.9c3.1-1.6,4.7-5.2,6.4-8c0.8-1.2,1.1-2.9,1.4-4.4c0.1-0.7-0.2-1-0.4-1.7c-0.2-1,0.2-2.2,0.1-3.2
        c-0.1-1-0.3-1.9-0.4-2.9c-0.1-1.1,0.1-2.1,0.2-3.2c0.1-2-0.2-4.1-0.2-6.1c0-3.7-0.1-7.4,0.3-11.1c0.1-0.9-0.2-1.8-0.2-2.7
        c0-0.8,0-1.6,0-2.5c-0.1-1.9,0-3.9-0.2-5.9c-0.2-1.8,0.4-3.5,0.2-5.3c-0.2-2.1,0-4.3-0.3-6.4c-0.6-4.1-0.9-8.2-1.2-12.4
        c-0.3-3.9-0.1-8.1-1.2-11.9c-0.5-1.7-1.7-2.9-3-4.1c-1.3-1.2-2.4-3-4.1-3.6c-1.5-0.6-3.3-1.4-4.9-1.6c-2.2-0.2-4.4-0.4-6.6-0.6
        c-1.9-0.2-3.8,0-5.7,0c-2.3,0-4.6,0-7,0c-4.8,0-9.6,0.2-14.4,0c-1.1,0-2.1,0.3-3.2,0.4c-1.2,0.1-2.3-0.1-3.5-0.2
        c-2.3-0.2-4.6-0.2-6.9-0.2c-4.8,0-9.8-0.2-14.6,0.1c-2.3,0.1-4.6,0.5-7,0.7c-1,0.1-2.2-0.1-3.1,0.1c-0.9,0.2-2.5,0.4-3.7,0.7
        c-0.5,0.1-0.9,0.4-1.4,0.6c-0.5,0.1-1,0.1-1.3,0.3c0,0,0.1,0.3,0,0.3c-0.1,0.1-0.3,0-0.5,0c-0.5,0.1-1.3,0-1.8-0.1
        c-1.2-0.1-2.1-0.3-3.1,0.5c-1.9,1.4-2.8,3.9-3.4,6c-0.3,1.2-0.5,2.3-0.7,3.6c-0.1,1.2-0.5,2.4-0.6,3.6c-0.3,3-0.2,6-0.2,9
        c0,2.6-0.4,5.3-0.1,7.9c0.1,1.2-0.1,2.4,0,3.6c0,0.6,0.2,1.1,0.2,1.7c0,0.8-0.3,1.5-0.2,2.3c0.1,1.2-0.1,2.2-0.1,3.5
        c-0.1,1.5,0.1,3,0.2,4.4c0.3,3.3,0.2,6.5,0.1,9.8c0,1.6-0.1,3.1,0,4.7c0.1,1.7,0.7,4.6,0.4,4.6c0.2,1.2,0,2.4,0,3.6
        c0,1.3,0.1,2.5,0.1,3.8c-0.1,2.5,0,4.6,0.7,7c0.6,2.3,0.8,4.5,1.8,6.6c0.4,0.9,0.7,1.8,1.3,2.5c0.5,0.6,1.2,1,1.6,1.7
        c0.2,0.3,0.2,0.6,0.4,0.8c0.3,0.2,0.8,0.9,0.9,1.2c0.1,0.5,0.4,0.8,0.7,1.2c1.2,1.3,2.7,3.1,4.4,3.7c1.9,0.7,3.7,0.4,5.6,0.7
        c0.8,0.2,0.9,0.5,1.7,0.7c1.2,0.3,2.3-0.1,3.5-0.1c1,0,1.6,0.2,2.4,0.6c0.8,0.4,1.8,0.3,2.7,0.2c1.3,0,2.6,0,3.9,0
        C37.3,105.1,38.8,104.7,40.2,104.7z M10.9,98.2L10.9,98.2C10.9,98.2,10.9,98.2,10.9,98.2z M3.8,64.2L3.8,64.2
        C3.8,64.2,3.8,64.2,3.8,64.2z M107,56.8L107,56.8L107,56.8z M109.7,50.9L109.7,50.9L109.7,50.9z M0.9,24.7
        C0.9,24.7,0.9,24.7,0.9,24.7C0.9,24.7,0.9,24.7,0.9,24.7z M4.1,7.4L4.1,7.4L4.1,7.4z M85.2,3.1L85.2,3.1C85.1,3.1,85.2,3.1,85.2,3.1
        z"
      ></path>
    </svg>
    <div class="icon" v-bind:style="{ backgroundImage: 'url(' + bgImage + '), none' }"></div>
  </li>
</template>

<script>
import { TweenMax } from 'gsap';
import iconWildAboutAnimals from 'images/theme-icons/icon-animals.png';
import iconBonesBodies from 'images/theme-icons/icon-bonesbodies.png';
import iconLetsEat from 'images/theme-icons/icon-food.png';
import iconGoGeography from 'images/theme-icons/icon-geography.png';
import iconGreatGrammar from 'images/theme-icons/icon-grammar.png';
import iconGreekLatin from 'images/theme-icons/icon-greeklatin.png';
import iconOffToWork from 'images/theme-icons/icon-jobs.png';
import iconJump from 'images/theme-icons/icon-jump.png';
import iconMathMix from 'images/theme-icons/icon-mathmix.png';
import iconStartMusic from 'images/theme-icons/icon-music.png';
import iconOhLook from 'images/theme-icons/icon-ohlook.png';
import iconPeoplePower from 'images/theme-icons/icon-peoplepower.png';
import iconSingPlay from 'images/theme-icons/icon-singplay.png';
import iconLetsPlay from 'images/theme-icons/icon-sports.png';
import iconSuperWords from 'images/theme-icons/icon-superwords.png';
import iconOnGo from 'images/theme-icons/icon-travel.png';
import iconWaterWater from 'images/theme-icons/icon-waterwater.png';
import iconWordsWriters from 'images/theme-icons/icon-wordswriters.png';
import getie from 'utils/ieversion.vue';

export default {
  data() {
    return {
      bgImage: '',
      isFaded: false,
      hideBg: false,
      isIE11: false
    };
  },
  mixins: [getie],
  props: ['active', 'animate', 'bgcolor', 'blockIndex', 'theme', 'totalNumberOfBlocks'],
  mounted() {
    const ieVersionNum = this.getIEVersion();

    if (ieVersionNum === 11) this.isIE11 = true;

    if (this.active === true && this.animate !== true) this.hideBg = true;
    if (this.active) this.isFaded = false;
    else this.isFaded = !this.active;

    this.bgImage = this.setThemeImage(this.theme);
    this.getAward();
  },
  methods: {
    setThemeImage(currentTheme) {
      let icon = '';

      switch (currentTheme) {
        case 'JumpIntoKeyboarding':
          icon = iconJump;
          break;

        case 'LetsEat':
          icon = iconLetsEat;
          break;

        case 'OffToWork':
          icon = iconOffToWork;
          break;

        case 'OnTheGo':
          icon = iconOnGo;
          break;

        case 'WildAboutAnimals':
          icon = iconWildAboutAnimals;
          break;

        case 'LetsPlay':
          icon = iconLetsPlay;
          break;

        case 'StartMusic':
          icon = iconStartMusic;
          break;

        case 'MathMix':
          icon = iconMathMix;
          break;

        case 'SingPlay':
          icon = iconSingPlay;
          break;

        case 'FamousFaces':
          icon = iconPeoplePower;
          break;

        case 'GreekLatin':
          icon = iconGreekLatin;
          break;

        case 'BonesBodies':
          icon = iconBonesBodies;
          break;

        case 'GreatGrammar':
          icon = iconGreatGrammar;
          break;

        case 'OhLook':
          icon = iconOhLook;
          break;

        case 'GoGeography':
          icon = iconGoGeography;
          break;

        case 'WordsWriters':
          icon = iconWordsWriters;
          break;

        case 'SuperWords':
          icon = iconSuperWords;
          break;

        case 'PeoplePower':
          icon = iconPeoplePower;
          break;

        case 'WaterWater':
          icon = iconWaterWater;
          break;

        case 'ArtStart':
          icon = iconOhLook;
          break;

        default:
      }

      return icon;
    },
    getAward() {
      if (this.animate) TweenMax.delayedCall(1, this.animatePath);
      const { bg } = this.$refs;
      bg.style.fill = this.bgcolor;
    },
    animatePath() {
      const { path } = this.$refs;
      if (!path) return;

      if (this.isIE11) {
        TweenMax.set(path, { autoAlpha: 0 });
        const vel = this.refs.highlightblock;
        // TweenMax.set(vel, {scaleX: 1.1, scaleY: 1.1, transformOrigin: 'center center'})
        TweenMax.to(vel, 0.5, {
          scaleX: 1.25,
          scaleY: 1.25,
          transformOrigin: 'center center',
          yoyo: true,
          repeat: 3
        });
      } else {
        const length = path.getTotalLength();
        // Clear any previous transition
        path.style.transition = 'none';
        path.style.WebkitTransition = 'none';
        // Set up the starting positions
        path.style.strokeDasharray = `${length} ${length}`;
        path.style.strokeDashoffset = '0';
        // Trigger a layout so styles are calculated & the browser
        // picks up the starting position before animating
        path.getBoundingClientRect();
        // Define our transition
        path.style.transition = 'stroke-dashoffset 1.2s linear';
        path.style.WebkitTransition = 'stroke-dashoffset 1.2s linear';
        // Go!
        path.style.strokeDashoffset = length;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.block {
  width: 110px;
  height: 108px;
  display: inline-block;
  margin: 5px;
  position: relative;
  &.faded {
    opacity: 0.25;
  }
}
.hide {
  display: none;
}
.icon {
  background-repeat: no-repeat;
  background-position: center center;
  width: 90px;
  height: 90px;
  position: absolute;
  top: 10px;
  left: 12px;
  background-size: contain;
}
</style>
